import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../../core/dto/page.size';
import { RentReservationService } from '../../../../core/services/rent-reservation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../../../../modules/auth/services/auth.service';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppUtils } from '../../../../core/config/app.utils';
import { CurrencyService } from '../../../../core/services/currency.service';
import { FleetService } from '../../../../core/services/fleet.service';
import { DriverService } from '../../../../core/services/driver.service';
import { SupplierService } from '../../../../core/services/supplier.service';
import { BehaviorSubject } from 'rxjs';
import { ReportsService } from '../../../../core/services/reports.service';
import { InventoryService } from '../../../../core/services/inventory.service';
import * as moment from 'moment';
import { UnitPipe } from '../../../../core/pipes/unit.pipe';
import { DecimalPipe, TitleCasePipe } from '@angular/common';
import { SETTINGS } from '../../../../core/config/common.settings';
import { UserService } from '../../../../core/services/user.service';

@Component({
  selector: 'app-single-view-rent-reservation',
  templateUrl: './single-view-rent-reservation.component.html',
  styleUrls: ['./single-view-rent-reservation.component.scss'],
  providers: [UnitPipe, DecimalPipe, TitleCasePipe],
})
export class SingleViewRentReservationComponent implements OnInit {
  breadcrumbs: any[] = [];
  loading = false;
  activeTabIndex = 0;

  receivedPayData: any[] = [];
  booking: any;
  bookingId: any;
  pageSize = new PageSize();

  //Current Fuel and Mileage Update Stuff
  isVisibleFuelAndMileageUpdate = false;
  changingStatus: any;
  fuelLevel: any = 0;
  mileage: any = 0;
  mileageAndFuelDataType = '';
  cancelReason: any = null;
  selectedReservation: any;
  isLoading = false;
  cancelReasonOptions: any[] = [
    'No Show',
    'No International License',
    'No Local License',
    'Vehicle Non Availability',
  ];
  index = 0;

  allocatedVehicle: any;

  specialInstruction = '';
  userComment = '';

  isVisibleCustomer = false;
  isVisibleDriver = false;
  isVisibleSupplier = false;
  customerData: any;
  supplierData: any;
  supplierId: any;
  driverData: any;

  isVisibleAddEditComment = false;
  comment: any;
  selectedComment: any;
  selectedCommentIndex: any;
  userComments: any[] = [];
  addEditCommentModalType = 'add';
  isLoadingCommentModal = false;

  visiblePaymentPopup = false;
  bookingPayments: any[] = [];
  paymentItems: any[] = [];
  extraCharges: any[] = [];

  // Add another allocation stuff
  isVisibleAddAllocation = false;
  allocationForm: FormGroup | any;
  formErrors: any;
  currencyOptions: any[] = [];
  fleetsOptions: any[] = [];
  vehicleCategories: any;
  driverPromotionDueOptions: any[] = [
    'No International Driving Permit',
    'No Local Driving Permit',
    'Vehicle Unavailability',
  ];
  driverOptions: any[] = [];
  supplierVehicleOptions: any[] = [];
  selectedOSDriver: any;
  visibleAddVehicleToSupplier = false;
  selectedSupplierId: any;
  selectedSupplierIdOnchange = new BehaviorSubject('');
  visibleAddDriverPopup = false;
  fleetsFetching = false;
  driversFetching = false;
  supplierVehiclesFetching = false;
  isShowReport = false;
  pdf: any;
  pdfLoader = false;
  username = '';

  isVisibleGenerateInventoryReport = false;
  fleetId: any;
  bookingData: any;

  haveInventoryRecords = false;
  relevantInventoryId: any;

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  // Rental Agreement generate PDF variables
  isVisibleGenerateReportModal = false;
  generateReportData: any;

  // Paging board variables
  isVisibleGeneratePagingBoardModal = false;
  defaultPagingBoardData: any;
  isReportPaymentReceipt = false;

  showStatusDropdown = false;

  constructor(
    private rentReservationService: RentReservationService,
    private currencyService: CurrencyService,
    private inventoryService: InventoryService,
    private route: ActivatedRoute,
    private messages: NzMessageService,
    private fleetService: FleetService,
    private driverService: DriverService,
    private supplierService: SupplierService,
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder,
    private reportService: ReportsService,
    private userService: UserService,
    private unitPipe: UnitPipe,
    private titleCasePipe: TitleCasePipe,
    private decimalPipe: DecimalPipe,
  ) {}

  ngOnInit() {
    this.bookingId = this.route.snapshot.paramMap.get('id');
    this.getRentReservationById();
    this.initAllocationForm();
    this.initAllocationFormErrors();
    this.getCurrencyOptions();
    this.getVehicleCategory();

    this.allocationForm.valueChanges.subscribe(() => {
      this.formErrors = AppUtils.getFormErrors(
        this.allocationForm,
        this.formErrors,
      );
    });

    this.userService.loggedInUserNameSubject.subscribe({
      next: (value) => {
        this.username = value;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  setBreadCrumbs(): void {
    this.breadcrumbs = [
      {
        title: `Rent Bookings `,
        route: '/admin/booking-rent',
        icon: 'car',
      },
      {
        title: `${this.booking?.refNo}`,
      },
    ];
  }

  getRentReservationById(): void {
    this.loading = true;
    this.rentReservationService
      .getReservationInDetail(this.bookingId)
      .subscribe((res: any) => {
        this.booking = res;
        this.customerData = res?.customerDetails?.customer;
        this.driverData = res?.allocationDetails?.allocatedDriver;
        this.supplierData = res?.allocatedDriversSupplier;
        this.supplierId = res?.allocatedDriversSupplier?._id;
        this.userComments = res?.otherDetails?.userComments;
        this.getAllocatedVehicle();
        this.setBreadCrumbs();
        this.specialInstruction =
          this.booking?.otherDetails?.specialInstruction;
        this.userComment = this.booking?.otherDetails?.userComment;
        this.bookingPayments = res?.payments?.sort(function (a: any, b: any) {
          return (
            new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
          );
        });
        this.loading = false;
        this.extraCharges =
          res?.bookingCostInformation?.extraCharges?.length > 0
            ? res?.bookingCostInformation?.extraCharges
            : [];

        if (this.booking?.allocationDetails?.allocatedVehicle) {
          this.inventoryService
            .getInventoryByFilter({
              fleet: this.booking?.allocationDetails?.allocatedVehicle?._id,
              'before.inspectionDetails.bookingDetails.booking':
                this.booking?._id,
            })
            .then((res: any) => {
              this.relevantInventoryId = res?._id;
              this.haveInventoryRecords = !!res;
            });
        }
      });
  }

  navigateTo(type: string): void {
    switch (type) {
      case 'edit':
        this.router.navigate([
          `/admin/booking-rent/add-edit/${this.bookingId}`,
          { pageName: 'single-view' },
        ]);
        break;
      case 'initial-allocated-vehicle-accident':
        this.router.navigate(
          [
            `/admin/fleets/${this.booking?.allocationDetails?.allocatedVehicle?._id}/accidents/add-edit`,
          ],
          {
            queryParams: {
              from: 'rent-booking-single-view',
              booking: this.booking?._id,
            },
          },
        );
        break;
      case 'customer':
        this.isVisibleCustomer = true;
        break;
      case 'driver':
        this.isVisibleDriver = true;
        break;
      case 'supplier':
        this.isVisibleSupplier = true;
        break;
      case 'vehicle-inspection':
        this.router.navigate([
          `admin/fleets/${this.booking?.allocationDetails?.allocatedVehicle._id}`,
          { pageName: 'fleetInventory' },
        ]);
        break;
    }
  }

  //Current fuel and mileage update stuff
  handleCancelUpdateFuelAndMileage(): void {
    this.isVisibleFuelAndMileageUpdate = false;
    this.fuelLevel = 0;
    this.mileage = 0;
    this.selectedReservation = null;
    this.changingStatus = null;
    this.mileageAndFuelDataType = '';
  }

  cancelDeleteComment(): void {}

  handleOkUpdateFuelAndMileage(): void {
    if (this.mileageAndFuelDataType === 'add-allocation') {
      this.isVisibleAddAllocation = true;
      this.isVisibleFuelAndMileageUpdate = false;
    } else {
      this.isLoading = true;
      const allocationDetails = this.booking?.allocationDetails;
      allocationDetails.vehicleCategory =
        allocationDetails?.isUpgraded || allocationDetails?.isDowngraded
          ? allocationDetails?.vehicleCategory?._id
          : null;
      allocationDetails.allocatedVehicle = allocationDetails?.allocatedVehicle
        ? allocationDetails?.allocatedVehicle?._id
        : null;
      allocationDetails.allocatedDriver = allocationDetails?.isDriverPromote
        ? allocationDetails?.allocatedDriver?._id
        : null;
      if (this.changingStatus === 'ON_RENT') {
        allocationDetails.startFuel = this.fuelLevel;
        allocationDetails.startMileage = this.mileage;
        this.rentReservationService
          .updateRentReservationFuelAndMileageData({
            allocationDetails,
            _id: this.bookingId,
            status: 'ON_RENT',
            updateType: 'status_change',
          })
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              this.messages.create('success', 'Status Changed to On Rent');
              this.updateFleetData('ON_RENT');
            },
            (e: any) => {
              this.messages.create('error', 'Error');
            },
          );
      } else if (this.changingStatus === 'COMPLETED') {
        allocationDetails.endFuel = this.fuelLevel;
        allocationDetails.endMileage = this.mileage;
        this.rentReservationService
          .updateRentReservationFuelAndMileageData({
            allocationDetails,
            _id: this.bookingId,
            status: 'COMPLETED',
            updateType: 'status_change',
          })
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              this.messages.create('success', 'Status Changed to Completed');
              this.updateFleetData('AVAILABLE');
            },
            (e: any) => {
              this.messages.create('error', 'Error');
            },
          );
      }
    }
  }

  updateFleetData(status: string): void {
    let payload: any = {};
    if (status === 'ON_RENT') {
      payload = {
        _id: this.booking?.allocationDetails?.allocatedVehicle,
        currentMileage: this.mileage,
        currentFuelLevel: this.fuelLevel,
        currentOnBooking: {
          type: 'RENT',
          id: this.booking?._id,
        },
        availabilityStatus: status,
      };
    } else {
      payload = {
        _id: this.booking?.allocationDetails?.allocatedVehicle,
        currentMileage: this.mileage,
        currentFuelLevel: this.fuelLevel,
        currentOnBooking: null,
        availabilityStatus: status,
      };
    }
    this.fleetService.updateFleet(payload).then(() => {
      this.getRentReservationById();
      this.isVisibleFuelAndMileageUpdate = false;
      this.changingStatus = null;
      this.fuelLevel = 0;
      this.mileage = 0;
    });
  }

  handleOkCancelledStatus(): void {
    this.isLoading = true;
    let remarks: any[] = this.booking?.remarks;
    if (remarks?.length > 0) {
      remarks?.push({
        action: 'Cancelled',
        remark: this.cancelReason,
        createdBy: this.authService.getLoggedInUser().userId,
        createdAt: new Date(),
      });
    } else {
      remarks = [
        {
          action: 'Cancelled',
          remark: this.cancelReason,
          createdBy: this.authService.getLoggedInUser().userId,
          createdAt: new Date(),
        },
      ];
    }
    this.rentReservationService
      .updateRentReservation({
        _id: this.bookingId,
        status: 'CANCELLED',
        remarks,
        updateType: 'status_change',
      })
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          this.isVisibleFuelAndMileageUpdate = false;
          this.messages.create('success', 'Status Changed to Cancelled');
          this.getRentReservationById();
          this.changingStatus = null;
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
  }

  handleOkSelectStatus(status: string): void {
    this.changingStatus = status;
    if (status === 'ON_RENT' || status === 'COMPLETED') {
      if (
        this.booking?.allocationDetails?.driverCategory !== 'OUTSOURCE_DRIVER'
      ) {
        this.isVisibleFuelAndMileageUpdate = true;
      } else {
        this.rentReservationService
          .updateRentReservation({
            _id: this.bookingId,
            status,
            updateType: 'status_change',
          })
          .subscribe(
            () => {
              this.isLoading = false;
              this.messages.create('success', `Status Changed to ${status}`);
              this.getRentReservationById();
              this.changingStatus = null;
            },
            () => {
              this.messages.create('error', 'Error');
            },
          );
      }
    } else if (status === 'CANCELLED') {
      this.isVisibleFuelAndMileageUpdate = true;
    } else if (status === 'RESERVATION') {
      this.rentReservationService
        .updateRentReservation({
          _id: this.bookingId,
          status: 'RESERVATION',
          updateType: 'status_change',
        })
        .subscribe(
          (res: any) => {
            this.isLoading = false;
            this.messages.create('success', 'Status Changed to Reservation');
            this.getRentReservationById();
            this.changingStatus = null;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  handleCancelSelectStatus(): void {
    this.changingStatus = null;
    this.isVisibleFuelAndMileageUpdate = false;
  }

  addItem(input: HTMLInputElement): void {
    const value = input.value;
    if (this.cancelReasonOptions.indexOf(value) === -1) {
      this.cancelReasonOptions = [
        ...this.cancelReasonOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  convertToNormalString(text: string): string {
    return _.startCase(_.toLower(text));
  }

  getTotalExtraCharges(): number {
    let total = 0;
    this.booking?.bookingCostInformation?.extraCharges?.forEach((ec: any) => {
      const amount = ec?.currencyDetails
        ? ec?.amount * ec?.currencyDetails?.lkrRate
        : ec?.amount;
      total = total + amount;
    });
    return total;
  }

  getTotalDeductions(): number {
    let total = 0;
    this.booking?.bookingCostInformation?.deductions?.forEach((de: any) => {
      const amount = de?.currencyDetails
        ? de?.amount * de?.currencyDetails?.lkrRate
        : de?.amount;
      total = total + amount;
    });
    return total;
  }

  getAllocatedVehicle(): void {
    if (
      this.booking?.allocationDetails?.isDriverPromote &&
      this.booking?.allocationDetails?.driverCategory === 'OUTSOURCE_DRIVER'
    ) {
      const vehicle = this.booking?.suppliersVehicles?.find(
        (vehi: any) =>
          vehi._id === this.booking?.allocationDetails?.allocatedDriverVehicle,
      );
      this.allocatedVehicle = {
        model: vehicle?.vehicleModel,
        registerNumber: vehicle?.registerNumber,
        yearOfManufacture: vehicle?.yearOfManufacture,
        supplierVehicleId: vehicle?._id,
      };
    } else {
      const vehicle = this.booking?.allocationDetails?.allocatedVehicle;
      this.allocatedVehicle = {
        model: vehicle?.vehicleModel,
        registerNumber: vehicle?.vehicleDetails?.registrationNumber,
        fleetId: vehicle?._id,
        brand: vehicle?.vehicleDetails?.vehicleBrand,
        fuelType: vehicle?.vehicleDetails?.fuelType,
        transmission: vehicle?.vehicleDetails?.transmission,
        numberOfSeats: vehicle?.vehicleDetails?.seatsNumber,
        color: vehicle?.vehicleDetails?.color,
        image:
          vehicle?.generalInformation?.vehicleImg?.length > 0
            ? vehicle?.generalInformation?.vehicleImg[0]
            : '',
      };
    }
  }

  getExceededDistance(): any {
    if (this.booking?.tourDetails?.mileagePreference === 'LIMITED') {
      if (
        this.booking?.allocationDetails?.endMileage &&
        this.booking?.allocationDetails?.startMileage
      ) {
        const exceeded =
          this.booking?.allocationDetails?.endMileage -
          this.booking?.allocationDetails?.startMileage -
          this.booking?.tourDetails?.limitedMileage;
        return exceeded.toString() + ' KM';
      }
    } else {
      return '-';
    }
  }

  visibleCustomerOnchange(event: any): void {
    if (event?.name === 'isVisible') {
      this.isVisibleCustomer = false;
    }
  }

  visibleDriverOnchange(event: any): void {
    if (event?.name === 'isVisible') {
      this.isVisibleDriver = false;
    }
  }

  visibleSupplierOnchange(event: any): void {
    if (event?.name === 'isVisible') {
      this.isVisibleSupplier = false;
    }
  }

  visibleAddEditComment(type: string, comment?: any, index?: number): void {
    this.addEditCommentModalType = type;
    if (type === 'edit') {
      this.selectedComment = comment;
      this.comment = this.selectedComment?.comment;
      this.selectedCommentIndex = index;
    }
    this.isVisibleAddEditComment = true;
  }

  deleteComment(index: number): void {
    this.isLoadingCommentModal = true;
    this.userComments?.splice(index, 1);
    this.rentReservationService
      .updateRentReservation({
        _id: this.bookingId,
        otherDetails: {
          ...this.booking?.otherDetails,
          userComments: this.userComments,
        },
      })
      .subscribe(
        (res: any) => {
          this.isLoadingCommentModal = false;
          this.comment = null;
          this.messages.create('success', 'Comment has been deleted!');
          this.getRentReservationById();
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
  }

  handleCancelAddEditComment(): void {
    this.isVisibleAddEditComment = false;
    this.comment = null;
  }

  handleSubmitUserComment(): void {
    this.isLoadingCommentModal = true;
    if (this.addEditCommentModalType === 'add') {
      if (this.userComments?.length > 0) {
        this.userComments?.push({
          comment: this.comment,
          createdBy: {
            _id: this.authService.getLoggedInUser().userId,
            name: this.username,
          },
          createdAt: new Date(),
        });
      } else {
        this.userComments = [
          {
            comment: this.comment,
            createdBy: {
              _id: this.authService.getLoggedInUser().userId,
              name: this.username,
            },
            createdAt: new Date(),
          },
        ];
      }
      this.rentReservationService
        .updateRentReservation({
          _id: this.bookingId,
          otherDetails: {
            ...this.booking?.otherDetails,
            userComments: this.userComments,
          },
        })
        .subscribe(
          (res: any) => {
            this.isLoadingCommentModal = false;
            this.isVisibleAddEditComment = false;
            this.comment = null;
            this.messages.create('success', 'New user comment has been added!');
            this.getRentReservationById();
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    } else {
      this.userComments[this.selectedCommentIndex] = {
        createdAt: this.selectedComment?.createdAt,
        comment: this.comment,
        createdBy: {
          _id: this.authService.getLoggedInUser().userId,
          name: this.username,
        },
      };
      this.rentReservationService
        .updateRentReservation({
          _id: this.bookingId,
          otherDetails: {
            ...this.booking?.otherDetails,
            userComments: this.userComments,
          },
        })
        .subscribe(
          (res: any) => {
            this.isLoadingCommentModal = false;
            this.isVisibleAddEditComment = false;
            this.comment = null;
            this.selectedComment = null;
            this.selectedCommentIndex = null;
            this.messages.create('success', 'User comment has been updated!');
            this.getRentReservationById();
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  visibleAddPayment(): void {
    this.setPaymentItems();
    this.rentReservationService.selectedReservationDetails.next({
      type: 'add',
      id: this.bookingId,
      payments:
        this.booking?.payments?.length > 0 ? this.booking?.payments : [],
    });
    this.visiblePaymentPopup = true;
  }

  editPayment(index: number, selectedPayment: any): void {
    this.setPaymentItems();
    this.rentReservationService.selectedReservationDetails.next({
      type: 'edit',
      id: this.bookingId,
      payments:
        this.booking?.payments?.length > 0 ? this.booking?.payments : [],
      index,
      selectedPayment,
    });
    this.visiblePaymentPopup = true;
  }

  setPaymentItems(): void {
    const pItems = this.extraCharges;
    if (this.booking?.bookingCostInformation?.rentalAmountDue) {
      pItems?.push({
        chargeType: 'Rental Amount Due',
        amount: this.booking?.bookingCostInformation?.rentalAmountDue,
        currency: this.booking?.bookingCostInformation?.rentalAmountDueCurrency,
        currencyDetails:
          this.booking?.bookingCostInformation?.rentalAmountDueCurrencyDetails,
      });
    }
    this.paymentItems = pItems;
  }

  onGetAddPaymentChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.paymentItems = [];
        this.visiblePaymentPopup = false;
        break;
      case 'created':
        this.messages.create('success', 'New Payment has been added!');
        this.getRentReservationById();
        this.visiblePaymentPopup = false;
        break;
    }
  }

  // Add another allocations stuff
  handleAddAnotherAllocation(): void {
    if (
      this.booking?.allocationDetails?.driverCategory !== 'OUTSOURCE_DRIVER'
    ) {
      this.isVisibleFuelAndMileageUpdate = true;
      this.mileageAndFuelDataType = 'add-allocation';
      this.getVehicles(this.booking?.tourDetails?.vehicleCategory?._id);
    } else {
      this.isVisibleAddAllocation = true;
    }
  }

  initAllocationForm(): void {
    this.allocationForm = this.fb.group({
      isUpgraded: [false],
      isDowngraded: [false],
      vehicleCategory: [null],
      allocatedVehicle: [null],
      isComplementary: [false],
      reason: [null, []],
      fuelType: [null, [Validators.required]],
      startFuel: [null, []],
      startMileage: [null, []],
      isDriverPromote: [false],
      driverPromotionDue: [null],
      driverPromotionOtherDue: [null],
      driverCategory: [null],
      isDriverPromotionCompCheck: [false],
      driverPromotionReason: [null],
      allocatedDriver: [null],
      allocatedDriverVehicle: [null],
      outsourcedRate: [null],
      outsourcedRateCurrency: ['65961e65cad7ae7c000623ff', []],
      outsourcedRateCurrencyDetails: [null, []],
    });

    // this.allocationForm.get('vehicleCategory').disable();
    // this.allocationForm.get('allocatedVehicle').disable();

    this.allocationForm.valueChanges.subscribe((values: any) => {
      if (values?.outsourcedRateCurrency) {
        const cu = this.currencyOptions?.find(
          (cu: any) => cu._id === values.outsourcedRateCurrency,
        );
        this.allocationForm.get('outsourcedRateCurrencyDetails').setValue(cu, {
          onlySelf: true,
          emitEvent: false,
        });
      }

      if (values.isUpgraded || values.isDowngraded) {
        if (
          values.isDriverPromote &&
          values.driverCategory === 'OUTSOURCE_DRIVER'
        ) {
          this.allocationForm.get('allocatedVehicle').clearValidators();
          this.allocationForm
            .get('allocatedVehicle')
            .updateValueAndValidity({ emitEvent: false });
        } else {
          this.allocationForm
            .get('allocatedVehicle')
            .addValidators(Validators.required);
          this.allocationForm
            .get('allocatedVehicle')
            .updateValueAndValidity({ emitEvent: false });
        }
        this.allocationForm
          .get('vehicleCategory')
          .addValidators(Validators.required);
        this.allocationForm
          .get('vehicleCategory')
          .updateValueAndValidity({ emitEvent: false });
      } else {
        this.allocationForm.get('vehicleCategory').clearValidators();
        this.allocationForm
          .get('vehicleCategory')
          .updateValueAndValidity({ emitEvent: false });
      }

      if (values.isComplementary === true) {
        this.allocationForm.get('reason').addValidators(Validators.required);
        this.allocationForm
          .get('reason')
          .updateValueAndValidity({ emitEvent: false });
      } else {
        this.allocationForm.get('reason').clearValidators();
        this.allocationForm
          .get('reason')
          .updateValueAndValidity({ emitEvent: false });
      }

      if (values.isDriverPromote) {
        if (values.isDriverPromotionCompCheck) {
          this.allocationForm
            .get('driverPromotionReason')
            .addValidators(Validators.required);
          this.allocationForm
            .get('driverPromotionReason')
            .updateValueAndValidity({ emitEvent: false });
        } else {
          this.allocationForm.get('driverPromotionReason').clearValidators();
          this.allocationForm
            .get('driverPromotionReason')
            .updateValueAndValidity({ emitEvent: false });
        }
        this.allocationForm
          .get('driverPromotionDue')
          .addValidators(Validators.required);
        this.allocationForm
          .get('driverCategory')
          .addValidators(Validators.required);
        this.allocationForm
          .get('allocatedDriver')
          .addValidators(Validators.required);

        this.allocationForm
          .get('driverPromotionDue')
          .updateValueAndValidity({ emitEvent: false });
        this.allocationForm
          .get('driverCategory')
          .updateValueAndValidity({ emitEvent: false });
        this.allocationForm
          .get('allocatedDriver')
          .updateValueAndValidity({ emitEvent: false });

        if (values.driverCategory === 'OUTSOURCE_DRIVER') {
          this.allocationForm
            .get('allocatedVehicle')
            .setValue(null, { emitEvent: false, onlySelf: true });
          this.allocationForm
            .get('allocatedDriverVehicle')
            .addValidators(Validators.required);
          this.allocationForm
            .get('allocatedDriverVehicle')
            .updateValueAndValidity({ emitEvent: false });
          // this.allocationForm.get('isUpgraded').disable();
          // this.allocationForm.get('isDowngraded').disable();
        } else {
          this.allocationForm.get('allocatedDriverVehicle').clearValidators();
          this.allocationForm
            .get('allocatedDriverVehicle')
            .updateValueAndValidity({ emitEvent: false });
          // this.allocationForm.get('isUpgraded').enable();
          // this.allocationForm.get('isDowngraded').enable();
        }
      } else {
        this.allocationForm.get('driverPromotionDue').clearValidators();
        this.allocationForm.get('driverCategory').clearValidators();
        this.allocationForm.get('allocatedDriver').clearValidators();
        this.allocationForm.get('driverPromotionReason').clearValidators();
        this.allocationForm.get('allocatedDriverVehicle').clearValidators();

        this.allocationForm
          .get('allocatedDriverVehicle')
          .updateValueAndValidity({ emitEvent: false });
        this.allocationForm
          .get('driverPromotionDue')
          .updateValueAndValidity({ emitEvent: false });
        this.allocationForm
          .get('driverCategory')
          .updateValueAndValidity({ emitEvent: false });
        this.allocationForm
          .get('allocatedDriver')
          .updateValueAndValidity({ emitEvent: false });
        this.allocationForm
          .get('driverPromotionReason')
          .updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  initAllocationFormErrors(): void {
    this.formErrors = {
      isUpgraded: {},
      isDowngraded: {},
      vehicleCategory: {},
      allocatedVehicle: {},
      isComplementary: {},
      reason: {},
      fuelType: {},
      startFuel: {},
      startMileage: {},
      isDriverPromote: {},
      driverPromotionDue: {},
      driverPromotionOtherDue: {},
      driverCategory: {},
      isDriverPromotionCompCheck: {},
      driverPromotionReason: {},
      allocatedDriver: {},
      allocatedDriverVehicle: {},
      outsourcedRate: {},
    };
  }

  getCurrencyOptions(): void {
    this.currencyService.getAllActiveCurrencies().subscribe((res: any) => {
      this.currencyOptions = res;
    });
  }

  handleCancelAllocation(): void {
    this.mileageAndFuelDataType = '';
    this.mileage = 0;
    this.fuelLevel = 0;
    this.allocationForm.reset();
    this.isVisibleAddAllocation = false;
  }

  setValues(event: any, type: string): void {
    this.fleetsOptions = [];
    this.allocationForm.get('allocatedVehicle').setValue(null, {
      onlySelf: true,
      emitEvent: false,
    });
    this.allocationForm.get('vehicleCategory').setValue(null, {
      onlySelf: true,
      emitEvent: false,
    });
    this.allocationForm.get('reason').reset();
    if (event) {
      this.allocationForm.get('vehicleCategory').enable();
      this.allocationForm.get('allocatedVehicle').enable();
      switch (type) {
        case 'downgrade':
          this.allocationForm.controls.isUpgraded.setValue(false, {
            onlySelf: true,
            // emitEvent: false,
          });
          this.allocationForm
            .get('isComplementary')
            .setValue(false, { onlySelf: true });
          this.allocationForm
            .get('isComplementary')
            .updateValueAndValidity({ emitEvent: false });
          this.allocationForm.get('reason').clearValidators();
          this.allocationForm
            .get('reason')
            .updateValueAndValidity({ emitEvent: false });
          break;
        case 'upgrade':
          this.allocationForm.controls.isDowngraded.setValue(false, {
            onlySelf: true,
            // emitEvent: false,
          });
          break;
      }
    }

    if (
      !this.allocationForm.get('isUpgraded').value &&
      !this.allocationForm.get('isDowngraded').value &&
      !event
    ) {
      this.allocationForm.get('vehicleCategory').disable();
      // this.allocationForm.get('allocatedVehicle').disable();
      this.fleetsOptions = [];
      this.allocationForm
        .get('allocatedVehicle')
        .addValidators(Validators.required);
      this.allocationForm
        .get('allocatedVehicle')
        .updateValueAndValidity({ emitEvent: false });
      this.fleetService
        .getFleetsAsOptions({
          category: this.booking?.tourDetails?.vehicleCategory?._id,
        })
        .then((res: any) => {
          this.fleetsOptions = res;
        });
      this.getVehicles(this.booking?.tourDetails?.vehicleCategory?._id);
    }
  }

  async getVehicleCategory(): Promise<void> {
    this.vehicleCategories = await this.fleetService.getAllVehicleCat();
  }

  getVehicles(event: any): void {
    if (event) {
      this.fleetsFetching = true;
      this.fleetsOptions = [];
      this.allocationForm.get('allocatedVehicle').setValue(null, {
        onlySelf: true,
        emitEvent: false,
      });
      if (event !== null) {
        this.fleetService
          .getFleetsAsOptions({ category: event })
          .then((res: any) => {
            this.fleetsFetching = false;
            this.fleetsOptions = res;
          });
      }
    }
  }

  checkValue(value: any): void {
    if (!value) {
      this.allocationForm.get('driverPromotionDue').reset();
      this.allocationForm.get('driverCategory').reset();
      this.allocationForm.get('isDriverPromotionCompCheck').reset();
      this.allocationForm.get('driverPromotionReason').reset();
      this.allocationForm.get('allocatedDriver').reset();
      this.allocationForm.get('allocatedDriverVehicle').reset();
      this.allocationForm.get('outsourcedRate').reset();
      this.allocationForm.get('outsourcedRateCurrency').reset();

      this.allocationForm
        .get('driverPromotionDue')
        .updateValueAndValidity({ emitEvent: false });
      this.allocationForm
        .get('driverCategory')
        .updateValueAndValidity({ emitEvent: false });
      this.allocationForm
        .get('isDriverPromotionCompCheck')
        .updateValueAndValidity({ emitEvent: false });
      this.allocationForm
        .get('driverPromotionReason')
        .updateValueAndValidity({ emitEvent: false });
      this.allocationForm
        .get('allocatedDriver')
        .updateValueAndValidity({ emitEvent: false });
      this.allocationForm
        .get('allocatedDriverVehicle')
        .updateValueAndValidity({ emitEvent: false });
      this.allocationForm
        .get('outsourcedRate')
        .updateValueAndValidity({ emitEvent: false });
      this.allocationForm
        .get('outsourcedRateCurrency')
        .updateValueAndValidity({ emitEvent: false });
      this.allocationForm.get('isUpgraded').enable();
      this.allocationForm.get('isDowngraded').enable();
    }
  }

  addDriverPromotionDue(input: any): void {
    const value = input.value;
    if (this.driverPromotionDueOptions.indexOf(value) === -1) {
      this.driverPromotionDueOptions = [
        ...this.driverPromotionDueOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  getDriverOptions(event?: any): void {
    this.allocationForm.get('allocatedDriver').reset();
    const payload = {
      driverSegment: event,
    };
    this.driversFetching = true;
    this.driverService.getDriverOptions(payload).subscribe((res: any) => {
      this.driversFetching = false;
      this.driverOptions = res;
    });
    if (
      this.allocationForm.get('isDriverPromote').value &&
      event === 'OUTSOURCE_DRIVER'
    ) {
      // this.rentBookingForm
      //   .get('allocationDetails')
      //   .controls.allocatedVehicle.setValue(null, {
      //   onlySelf: true,
      //   emitEvent: false,
      // });
      this.allocationForm.controls['allocatedVehicle'].disable();
      this.allocationForm.controls['vehicleCategory'].disable();
      this.allocationForm.controls['fuelType'].disable();
      // this.allocationForm.controls['startFuel'].disable();
      // this.allocationForm.controls['startMileage'].disable();
      this.allocationForm.get('isUpgraded').disable();
      this.allocationForm.get('isDowngraded').disable();
      this.allocationForm.controls['fuelType'].reset();
      this.allocationForm.controls['startFuel'].reset();
      this.allocationForm.controls['startMileage'].reset();
      this.allocationForm.controls['fuelType'].clearValidators();
      this.allocationForm.controls['fuelType'].updateValueAndValidity({
        emitEvent: false,
      });
      this.allocationForm.controls['outsourcedRate'].addValidators(
        Validators.required,
      );
      this.allocationForm.controls['outsourcedRate'].updateValueAndValidity({
        emitEvent: false,
      });
    } else {
      this.allocationForm.controls['allocatedVehicle'].enable();
      this.allocationForm.controls['vehicleCategory'].enable();
      this.allocationForm.controls['fuelType'].enable();
      this.allocationForm.controls['startFuel'].enable();
      this.allocationForm.controls['startMileage'].enable();
      this.allocationForm.get('isUpgraded').enable();
      this.allocationForm.get('isDowngraded').enable();
      this.allocationForm.controls['outsourcedRate'].clearValidators();
      this.allocationForm.controls['outsourcedRate'].updateValueAndValidity({
        emitEvent: false,
      });
      this.allocationForm.controls['fuelType'].addValidators(
        Validators.required,
      );
      this.allocationForm.controls['fuelType'].updateValueAndValidity({
        emitEvent: false,
      });
    }
  }

  getSupplierVehicles(event: any): void {
    this.allocationForm.get('allocatedDriverVehicle').reset();
    if (
      this.allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER'
    ) {
      this.supplierVehiclesFetching = true;
      if (event) {
        this.supplierVehicleOptions = [];
        this.driverService
          .getSupplierVehiclesByDriver(event)
          .subscribe((res: any) => {
            this.supplierVehiclesFetching = false;
            this.selectedOSDriver = event;
            this.supplierVehicleOptions = res?.supplierVehicles;
            this.supplierService.supplierVehiclesOnChange.next(
              res?.supplierVehicles,
            );
            this.selectedSupplierId = res?.supplierId;
            this.selectedSupplierIdOnchange.next(res?.supplierId);
            // }
          });
      } else {
        this.supplierVehiclesFetching = false;
      }
    }
  }

  showAddVehicleToSupplier(): void {
    this.driverService.supplierVehicleFormType.next('add');
    this.visibleAddVehicleToSupplier = true;
  }

  addVehicleOnChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddVehicleToSupplier = false;
        break;
      case 'submit':
        this.visibleAddVehicleToSupplier = false;
        this.driverService
          .getSupplierVehiclesByDriver(this.selectedOSDriver)
          .subscribe((res: any) => {
            this.supplierVehicleOptions = res?.supplierVehicles;
            // }
          });
        break;
    }
  }

  showAddDriverPopup(): void {
    this.driverService.initAddDriverPopupForm.next(true);
    this.visibleAddDriverPopup = true;
  }

  onGetAddDriverChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddDriverPopup = false;
        break;
      case 'created':
        this.messages.create('success', 'New Driver has been added!');
        this.allocationForm.get('allocatedDriver').reset();
        this.allocationForm.get('driverCategory').setValue(event.value, {
          onlySelf: true,
          emitEvent: false,
        });
        this.getDriverOptions(event.value);
        this.visibleAddDriverPopup = false;
        break;
    }
  }

  async saveAllocation(): Promise<any> {
    const formData = this.allocationForm.getRawValue();
    let allocationList = [];
    allocationList = this.booking?.allocationList;
    const existAllocation = this.booking?.allocationDetails;
    existAllocation.allocatedVehicle = this.booking?.allocationDetails
      ?.allocatedVehicle
      ? {
          _id: this.booking?.allocationDetails?.allocatedVehicle?._id,
          model:
            this.booking?.allocationDetails?.allocatedVehicle?.vehicleDetails
              ?.vehicleModel,
          registrationNo:
            this.booking?.allocationDetails?.allocatedVehicle?.vehicleDetails
              ?.registrationNumber,
          brand:
            this.booking?.allocationDetails?.allocatedVehicle?.vehicleDetails
              ?.vehicleBrand,
          color:
            this.booking?.allocationDetails?.allocatedVehicle?.vehicleDetails
              ?.color,
          image:
            this.booking?.allocationDetails?.allocatedVehicle
              ?.generalInformation?.vehicleImg?.length > 0
              ? this.booking?.allocationDetails?.allocatedVehicle
                  ?.generalInformation?.vehicleImg[0]
              : '',
          fuelType:
            this.booking?.allocationDetails?.allocatedVehicle?.vehicleDetails
              ?.fuelType,
          transmission:
            this.booking?.allocationDetails?.allocatedVehicle?.vehicleDetails
              ?.transmission,
          numberOfSeats:
            this.booking?.allocationDetails?.allocatedVehicle?.vehicleDetails
              ?.seatsNumber,
        }
      : null;
    existAllocation.vehicleCategory = this.booking?.allocationDetails
      ?.vehicleCategory
      ? {
          _id: this.booking?.allocationDetails?.vehicleCategory?._id,
          name: this.booking?.allocationDetails?.vehicleCategory?.name,
        }
      : null;
    existAllocation.allocatedDriver = this.booking?.allocationDetails
      ?.allocatedDriver
      ? {
          _id: this.booking?.allocationDetails?.allocatedDriver?._id,
          fullName: this.booking?.allocationDetails?.allocatedDriver?.fullName,
          canDrive: this.booking?.allocationDetails?.allocatedDriver?.canDrive,
          nicNo: this.booking?.allocationDetails?.allocatedDriver?.nicNo,
          mobileNumber:
            this.booking?.allocationDetails?.allocatedDriver?.mobileNumber,
          email: this.booking?.allocationDetails?.allocatedDriver?.email,
          driverSegment:
            this.booking?.allocationDetails?.allocatedDriver?.driverSegment,
          supplier:
            this.booking?.allocationDetails?.driverCategory ===
            'OUTSOURCE_DRIVER'
              ? this.booking?.allocatedDriversSupplier?.supplierDetails?.name
              : undefined,
          supplierId:
            this.booking?.allocationDetails?.driverCategory ===
            'OUTSOURCE_DRIVER'
              ? this.booking?.allocatedDriversSupplier?._id
              : undefined,
        }
      : null;
    if (existAllocation?.driverCategory === 'OUTSOURCE_DRIVER') {
      existAllocation.allocatedDriverVehicle =
        this.booking?.suppliersVehicles?.find(
          (vehicle: any) =>
            vehicle?._id === existAllocation?.allocatedDriverVehicle,
        );
    }
    existAllocation.endFuel = this.fuelLevel;
    existAllocation.endMileage = this.mileage;
    existAllocation.endFuelAndMileageUpdatedAt = new Date();

    if (this.booking?.allocationList?.length > 0) {
      allocationList?.push(existAllocation);
    } else {
      allocationList = [{ ...existAllocation }];
    }

    this.rentReservationService
      .updateRentReservationFuelAndMileageData({
        _id: this.bookingId,
        allocationDetails: formData,
        allocationList,
        status: this.booking?.status,
        updateType: 'add_another_allocation',
      })
      .subscribe((res: any) => {
        this.messages.create(
          'success',
          'New Allocation is added successfully!',
        );

        this.updateAllocatedFleetsInfo(existAllocation, formData).then(() => {
          this.getRentReservationById();
          this.mileageAndFuelDataType = '';
          this.mileage = 0;
          this.fuelLevel = 0;
          this.allocationForm.reset();
          this.isVisibleAddAllocation = false;
        });
      });
  }

  async updateAllocatedFleetsInfo(
    existAllocation: any,
    formData: any,
  ): Promise<any> {
    try {
      const results = await Promise.allSettled([
        new Promise((resolve, reject) => {
          if (existAllocation?.driverCategory !== 'OUTSOURCE_DRIVER') {
            this.fleetService
              .updateFleet({
                _id: existAllocation?.allocatedVehicle?._id,
                currentMileage: this.mileage,
                currentFuelLevel: this.fuelLevel,
                currentOnBooking: null,
                availabilityStatus: 'AVAILABLE',
              })
              .then(resolve)
              .catch(reject);
          }
        }),
        new Promise((resolve, reject) => {
          if (formData?.driverCategory !== 'OUTSOURCE_DRIVER') {
            this.fleetService
              .updateFleet({
                _id: formData?.allocatedVehicle,
                currentMileage: formData?.startMileage
                  ? formData?.startMileage
                  : undefined,
                currentFuelLevel: formData?.startFuel
                  ? formData?.startFuel
                  : undefined,
                currentOnBooking: {
                  type: 'RENT',
                  id: this.booking._id,
                },
                availabilityStatus: 'ON_RENT',
              })
              .then(resolve)
              .catch(reject);
          }
        }),
      ]);
    } catch (error) {
      console.error('Error updating fleets:', error);
    }
  }

  getNumberWithPad(num: number): string {
    const str = num.toString();
    return str.padStart(2, '0');
  }

  showReportGenerate(isPaymentReceipt: boolean): void {
    this.isReportPaymentReceipt = isPaymentReceipt;
    this.isShowReport = true;
  }

  handleCancel(): void {
    this.isShowReport = false;
    this.pdf = null;
    this.isReportPaymentReceipt = false;
  }

  generatePdf(receiptData?: any): void {
    this.pdfLoader = false;
    if (this.isReportPaymentReceipt) {
      const payload = {
        recordInfo: {
          receiptNo: '00001',
          bookingRefNo: this.booking.refNo,
          createdAt: receiptData.createdAt,
          agentRefNo:
            this.booking?.bookingDetails?.bookingType === 'THROUGH_AGENT'
              ? this.booking?.bookingDetails?.bookingReferenceNo
              : undefined,
          type: receiptData.type,
          totalAmount: receiptData.totalAmount,
        },
        customerInfo: {
          name: this.booking?.customerDetails?.customer?.renterDetails
            ?.fullName,
          address:
            this.booking?.customerDetails?.customer?.renterDetails?.homeAddress,
          contactNo:
            this.booking?.customerDetails?.customer?.renterDetails?.contactNo,
        },
        items: receiptData.items,
      };
      this.reportService.generatePaymentReceipt(payload).then((res) => {
        this.pdf = res;
        this.pdfLoader = true;
      });
    } else {
      this.reportService
        .generateOutsourcedReport(this.booking, 'flag')
        .then((res) => {
          this.pdf = res;
          this.pdfLoader = true;
        });
    }
  }

  emailPdf(): void {
    this.reportService.emailPdf();
    // const email = 'recipient@gmail.com';
    // const subject = 'Your email subject';
    // const body = 'Your email body content';
    //
    // // Create the mailto link
    // // Open the default email client (Gmail, if available)
    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //   subject,
    // )}&body=${encodeURIComponent(body)}`;
  }

  printReport(): void {
    this.reportService.printReport(this.pdf).then(() => {});
  }

  viewPdf(): void {
    this.reportService.viewReport(this.pdf);
  }

  downloadPdf(): void {
    this.reportService.downloadReport(this.pdf);
  }

  showGenerateInventoryReportPopup(): void {
    let agentName = '';
    if (this.booking?.bookingDetails?.bookingType === 'THROUGH_AGENT') {
      if (this.booking?.bookingDetails?.agent?.name === 'Green Motion') {
        agentName = 'GREEN_MOTION';
      } else if (this.booking?.bookingDetails?.agent?.name === 'Europcar') {
        agentName = 'EUROPCAR';
      } else {
        agentName = 'SR_RENT_A_CAR';
      }
    }
    this.fleetId = this.booking?.allocationDetails?.allocatedVehicle._id;
    this.bookingData = {
      bookingId: this.bookingId,
      bookingRefNo: this.booking?.refNo,
      bookingAgent:
        this.booking?.bookingDetails?.bookingType === 'THROUGH_AGENT'
          ? agentName
          : null,
      onlyRecord: false,
    };
    this.isVisibleGenerateInventoryReport = true;
  }

  onGetGenerateInventoryReportChange(event: any): void {
    switch (event.name) {
      case 'visible':
        this.isVisibleGenerateInventoryReport = false;
        break;
    }
  }

  openRentalAgreementModal(): void {
    this.isVisibleGenerateReportModal = true;
    const drivenKm =
      this.booking?.allocationDetails?.endFuel -
      this.booking?.allocationDetails?.startMileage;
    this.generateReportData = {
      header: {
        // recordNo: , Add record number from back-end
        currentDate: moment().format('MMM Do, YYYY').toString(),
        bookingNo: this.booking?.refNo,
      },
      agent: {
        name: this.booking?.bookingDetails?.agent?.name,
        bookingNo: this.booking?.bookingDetails?.bookingReferenceNo,
      },
      noOfPassengers: this.booking?.tourDetails?.numberOfPassengers,
      customer: {
        name: this.booking?.customerDetails?.customer?.renterDetails?.fullName,
        address:
          this.booking?.customerDetails?.customer?.renterDetails?.homeAddress,
        number:
          this.booking?.customerDetails?.customer?.renterDetails?.contactNo,
        country:
          this.booking?.customerDetails?.customer?.renterDetails?.homeCountry,
        dateOfBirth: moment(
          this.booking?.customerDetails?.customer?.renterDetails?.dob,
        )
          .format('MMM Do YY')
          .toString(),
        birthCity:
          this.booking?.customerDetails?.customer?.renterDetails?.birthCity,
        birthCountry:
          this.booking?.customerDetails?.customer?.renterDetails?.birthCountry,
        passport: {
          no: this.booking?.customerDetails?.customer?.passportLicenceDetails
            ?.passportNo,
          issuedDate: moment(
            this.booking?.customerDetails?.customer?.passportLicenceDetails
              ?.issueDatePass,
          )
            .format('MMM Do YY')
            .toString(),
          expireDate: moment(
            this.booking?.customerDetails?.customer?.passportLicenceDetails
              ?.expiryDatePass,
          )
            .format('MMM Do YY')
            .toString(),
        },
        drivingLicense: {
          no: this.booking?.customerDetails?.customer?.passportLicenceDetails
            ?.drivingLicenceNo,
          issuedDate: moment(
            this.booking?.customerDetails?.customer?.passportLicenceDetails
              ?.issueDateLicence,
          )
            .format('MMM Do YY')
            .toString(),
          expireDate: moment(
            this.booking?.customerDetails?.customer?.passportLicenceDetails
              ?.expiryDateLicence,
          )
            .format('MMM Do YY')
            .toString(),
        },
        localNumber: this.booking?.customerDetails?.localContactNo,
        localAddress: this.booking?.customerDetails?.localAddress,
      },
      secondDriver: {
        name: this.booking?.customerDetails?.secondDriverDetails?.driverName,
        drivingLicense: {
          no: this.booking?.customerDetails?.secondDriverDetails
            ?.drivingLicenseNumber,
          issuedDate: moment(
            this.booking?.customerDetails?.secondDriverDetails
              ?.drivingLicenseIssuedDate,
          )
            .format('MMM Do YY')
            .toString(),
          expireDate: moment(
            this.booking?.customerDetails?.secondDriverDetails
              ?.drivingLicenseExpiryDate,
          )
            .format('MMM Do YY')
            .toString(),
        },
      },
      departure: {
        flightNo:
          this.booking?.tourDetails?.departureInformation?.departureFlightNo,
        date: moment(
          this.booking?.tourDetails?.actualInformation?.actualEndDate
            ? this.booking?.tourDetails?.actualInformation?.actualEndDate
            : this.booking?.tourDetails?.departureInformation?.departureDate,
        )
          .format('MMM Do YY')
          .toString(),
        time: moment(
          this.booking?.tourDetails?.actualInformation?.actualEndTime
            ? this.booking?.tourDetails?.actualInformation?.actualEndTime
            : this.booking?.tourDetails?.departureInformation?.departureTime,
        )
          .format('LT')
          .toString(),
        dropOff:
          this.booking?.tourDetails?.departureInformation?.dropOffLocation,
        handler:
          this.booking?.departureHandler?.firstname +
          ' ' +
          this.booking?.departureHandler?.lastname,
      },
      arrival: {
        pickUp: this.booking?.tourDetails?.arrivalInformation?.pickUpLocation,
        handler:
          this.booking?.arrivalHandler?.firstname +
          ' ' +
          this.booking?.arrivalHandler?.lastname,
      },
      vehicle: {
        regiNumber: this.allocatedVehicle?.registerNumber,
        fuelType: this.allocatedVehicle?.fuelType,
        model: this.allocatedVehicle?.model,
        start: {
          mileage: this.unitPipe.transform(
            this.booking?.allocationDetails?.startMileage
              ? this.booking?.allocationDetails?.startMileage
              : '',
          ),
          fuel: this.unitPipe.transform(
            this.booking?.allocationDetails?.startFuel
              ? this.booking?.allocationDetails?.startFuel
              : '',
            '%',
          ),
          date: moment(
            this.booking?.allocationDetails?.startFuelAndMileageUpdatedAt,
          )
            .format('MMM Do YY')
            .toString(),
          time: moment(
            this.booking?.allocationDetails?.startFuelAndMileageUpdatedAt,
          )
            .format('LT')
            .toString(),
        },
        end: {
          mileage: this.unitPipe.transform(
            this.booking?.allocationDetails?.endMileage
              ? this.booking?.allocationDetails?.endMileage
              : '',
          ),
          fuel: this.unitPipe.transform(
            this.booking?.allocationDetails?.endFuel
              ? this.booking?.allocationDetails?.endFuel
              : '',
            '%',
          ),
          date: moment(
            this.booking?.allocationDetails?.endFuelAndMileageUpdatedAt,
          )
            .format('MMM Do YY')
            .toString(),
          time: moment(
            this.booking?.allocationDetails?.endFuelAndMileageUpdatedAt,
          )
            .format('LT')
            .toString(),
        },
        limitation: this.titleCasePipe.transform(
          this.booking?.tourDetails?.mileagePreference,
        ),
        drivenKm: this.unitPipe.transform(drivenKm ? drivenKm : ''),
        entitledKm: this.unitPipe.transform(
          this.booking?.tourDetails?.limitedMileage
            ? this.booking?.tourDetails?.limitedMileage
            : '',
        ),
        chargePerKm:
          this.booking?.tourDetails?.costPerExtraMileage +
          ' ' +
          this.booking?.tourDetails?.costPerExtraMileageCurrencyDetails
            ?.currencyCode,
        chargedKm: this.unitPipe.transform(
          this.booking?.tourDetails?.limitedMileage < drivenKm
            ? drivenKm - this.booking?.tourDetails?.limitedMileage
            : '',
        ),
      },
      cost: {
        totalRental: this.decimalPipe.transform(
          this.booking?.bookingCostInformation?.totalRentalAmount
            ? this.booking?.bookingCostInformation?.totalRentalAmount *
                this.booking?.bookingCostInformation
                  ?.totalRentalAmountCurrencyDetails?.lkrRate
            : '',
          '1.2-2',
        ),
        prepaidAmount: this.decimalPipe.transform(
          this.booking?.bookingCostInformation?.prepaidAmount
            ? this.booking?.bookingCostInformation?.prepaidAmount *
                this.booking?.bookingCostInformation
                  ?.prepaidAmountCurrencyDetails?.lkrRate
            : '',
          '1.2-2',
        ),
        deposit: this.decimalPipe.transform(
          this.booking?.bookingCostInformation?.deposit
            ? this.booking?.bookingCostInformation?.deposit *
                this.booking?.bookingCostInformation?.depositCurrencyDetails
                  ?.lkrRate
            : '',
          '1.2-2',
        ),
        totalExtraCharges: this.decimalPipe.transform(
          this.getTotalExtraCharges(),
          '1.2-2',
        ),
        totalDeductions: this.decimalPipe.transform(
          this.getTotalDeductions(),
          '1.2-2',
        ),
        totalCost: this.decimalPipe.transform(
          this.booking?.bookingCostInformation?.rentalAmountDue *
            this.booking?.bookingCostInformation?.rentalAmountDueCurrencyDetails
              ?.lkrRate +
            this.getTotalExtraCharges() -
            this.getTotalDeductions(),
          '1.2-2',
        ),
      },
    };
  }

  onGenerateReportChange(event: any): void {
    switch (event.action) {
      case 'Invisible':
        this.isVisibleGenerateReportModal = false;
        this.generateReportData = null;
        break;
    }
  }

  openGeneratePagingBoardModal() {
    this.isVisibleGeneratePagingBoardModal = true;
    this.defaultPagingBoardData = {
      type: 'Arrival',
      customer:
        this.booking?.customerDetails?.customer?.renterDetails?.fullName,
      date: this.booking?.tourDetails?.actualInformation?.actualStartDate
        ? this.booking?.tourDetails?.actualInformation?.actualStartDate
        : this.booking?.tourDetails?.arrivalInformation?.arrivalDate,
      time: this.booking?.tourDetails?.actualInformation?.actualStartTime
        ? this.booking?.tourDetails?.actualInformation?.actualStartTime
        : this.booking?.tourDetails?.arrivalInformation?.arrivalTime,
      flight: this.booking?.tourDetails?.arrivalInformation?.arrivalFlightNo,
      dropLocation:
        this.booking?.tourDetails?.arrivalInformation?.pickUpLocation,
      numOfPax: this.booking?.tourDetails?.numberOfPassengers,
      vehicleCategory: this.booking?.tourDetails?.vehicleCategory?._id,
      customerNumber:
        this.booking?.customerDetails?.customer?.renterDetails?.contactNo,
      agent: this.booking?.bookingDetails?.agent?.name,
    };
  }

  onGetGeneratePagingBoardChange(event: any): void {
    switch (event.action) {
      case 'Invisible':
        this.isVisibleGeneratePagingBoardModal = false;
        break;
    }
  }

  havePermissionWithStatus(
    bookingStatus: string,
    permission: string,
    checkingStatus: string,
    have: boolean,
  ): boolean {
    if (have) {
      return (
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          permission,
        ) && bookingStatus === checkingStatus
      );
    } else {
      return (
        !_.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          permission,
        ) && bookingStatus === checkingStatus
      );
    }
  }

  checkCanShowGenerateInventoryReport(): boolean {
    return (
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'REPORT_GENERATE',
      ) && this.haveInventoryRecords
    );
  }

  canChangeToOnRent(): boolean {
    if (this.booking?.allocationDetails?.isDriverPromote) {
      if (this.booking?.allocationDetails?.driverCategory === 'SR_DRIVER') {
        return this.booking?.allocationDetails?.allocatedVehicle?._id;
      } else {
        return this.booking?.allocationDetails?.allocatedDriverVehicle;
      }
    } else {
      return this.booking?.allocationDetails?.allocatedVehicle?._id;
    }

    // normal vehicle allocation situation
    // if isDriverUpgrade
    // if SR_DRIVER
    // allocatedVehicle
    // if OUTSOURCE_DRIVER
    // allocatedSupplierVehicle
    // else
    // allocatedVehicle

    // vehicle allocate with SR Driver

    // supplierVehicle with OUTSOURCE Driver
  }
}
